import { requestAuthenticationStatus, requestLogout } from "./authenticationRequests";
import {logoutSuccess} from "../../../authentication/actions/authenticationActions";

export const AUTHENTICATION_FETCH_SUCCESS = "AUTHENTICATION_FETCH_SUCCESS";

export function authenticationFetchSuccess(authenticationStatus) {
    return {
        type: AUTHENTICATION_FETCH_SUCCESS,
        payload: authenticationStatus
    };
}

export function checkAuthentication() {
    return (dispatch, getState) => {
        requestAuthenticationStatus(authenticationStatus => {
            dispatch(authenticationFetchSuccess(authenticationStatus));
        });
    };
}

export function logout() {
    return (dispatch, getState) => {
        requestLogout(logoutStatus => {
            dispatch(logoutSuccess());
            const location = global.window.location;
            location.assign(location.origin);
        });
    };
}


/** WEBPACK FOOTER **
 ** ./src/main/javascript/disclosure/authentication/actions/authenticationActions.js
 **/